/**
 * @generated SignedSource<<6467d18debdc2c53573eae85675c6b80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecordingControls_note$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StartAndAutoRecordingControls_note">;
  readonly " $fragmentType": "RecordingControls_note";
};
export type RecordingControls_note$key = {
  readonly " $data"?: RecordingControls_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecordingControls_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecordingControls_note",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StartAndAutoRecordingControls_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "b418dac7e63d06605d0ae6b58449e6c7";

export default node;
